import React from "react";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";

const CheckEmailPage = () => {
  return (
    <>
      <div className="flex flex-col h-screen w-full items-center">
        <img src={logo} alt="logo" className="w-[50%] logo" />
        <div className="flex flex-col w-[50%] signup mt-16">
          <div className="text-[20px] text-[#2F80ED] mb-2">
            Check Your Email
          </div>
          <div className="text-[16px] my-2">
            We have sent you the password recovery instruction to your email.
          </div>
          <button className="py-[16px] text-[#2F80ED] underline">
            <Link to="/create-password">Skip, I'll confirm later</Link>
          </button>
          <Link to="mailto:email@example.com">
            <button className="w-full border-none bg-[#2F80ED] py-[14px] text-white rounded-lg">
              Open Email App
            </button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default CheckEmailPage;
